import './page-header.styles.scss';

const PageHeader = ({ overline, title, lead }) => (
  <header className="page-header">
    {overline && <p className="page-header-overline">{overline}</p>}
    <h1 className="page-header-title">{title}</h1>
    {lead && <p className="page-header-lead">{lead}</p>}
  </header>
);

export default PageHeader;
